import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactItemsParts = ['container', 'text', 'scrollContainer'] as const

const helpers = createMultiStyleConfigHelpers(ContactItemsParts)

export const ContactItemsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      height: { base: 'fit-content', sm: 'auto' },
      backgroundColor: 'bg.default',
      flex: '1 0 0',
      paddingX: '1.75rem',
      paddingTop: '2.5rem',
      paddingBottom: '1.25rem',
      borderRadius: '0.5rem',
      border: '2px solid',
      borderColor: 'border.muted',
    },
    text: {
      width: 'full',
      paddingBottom: '0.75rem',
      borderBottom: '1px solid',
      borderColor: 'border.default',
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    scrollContainer: {
      overflowY: { base: 'visible', sm: 'scroll' },
    },
  },
})

export const useContactItemsStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactItemsStyle, props) as MultiStyleType<
    typeof ContactItemsParts
  >
}
